import { useEffect } from "react";
import {
  Outlet,
  useSearchParams,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { PageLoader } from "../common/Loaders/PageLoader";
import { useAppSelector } from "../../hooks/redux";
import { loaderSelector } from "../../store/slices/loaderSlice";
import { useTrackNavigationHistory } from "../../hooks/useNavigationHistory";
import { AuthPromptProvider } from "../../contexts/AuthPromptContext";
import "react-toastify/dist/ReactToastify.css";

function MainLayout() {
  const showLoader = useAppSelector(loaderSelector);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthRoute = location.pathname.startsWith("/auth");
  useTrackNavigationHistory();

  useEffect(() => {
    const code = searchParams.get("code");
    const error = searchParams.get("error");

    // If Cognito redirects to the root URL with a code/error param,
    // forward to /auth/sso/callback so the SSO flow can process it
    if (location.pathname === "/" && (code || error)) {
      const params = new URLSearchParams(searchParams.toString());
      navigate(`/auth/sso/callback?${params.toString()}`, { replace: true });
    }
  }, [location.pathname, searchParams, navigate]);

  return (
    <AuthPromptProvider>
      <main className="main-wrapper">
        <Outlet />
        {showLoader && !isAuthRoute && <PageLoader />}
        <ToastContainer />
      </main>
    </AuthPromptProvider>
  );
}

export default MainLayout;
